import React from 'react';
import { T, CARD, Field, DarkInput, SaveBtn } from './ContentShared';

const HeroEditor = ({ data, setData, onSave, saving }) => {
  if (!data) return null;
  const set = (key, val) => setData({ ...data, [key]: val });

  return (
    <div className="space-y-6" data-testid="hero-editor">
      <div className="rounded-2xl p-6 space-y-5" style={CARD}>
        <h2 className="text-base font-semibold" style={{ fontFamily: "'Playfair Display', serif", color: T.textPrimary }}>Section Hero Video</h2>
        <Field label="URL Vidéo principale"><DarkInput value={data.video_url} onChange={e => set('video_url', e.target.value)} placeholder="https://..." testId="hero-video-url" /></Field>
        <Field label="URL Vidéo de secours"><DarkInput value={data.fallback_video_url} onChange={e => set('fallback_video_url', e.target.value)} placeholder="https://..." testId="hero-fallback-url" /></Field>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Titre (FR)"><DarkInput value={data.title_fr} onChange={e => set('title_fr', e.target.value)} testId="hero-title-fr" /></Field>
          <Field label="Titre (EN)"><DarkInput value={data.title_en} onChange={e => set('title_en', e.target.value)} testId="hero-title-en" /></Field>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Sous-titre (FR)"><DarkInput value={data.subtitle_fr} onChange={e => set('subtitle_fr', e.target.value)} rows={2} testId="hero-subtitle-fr" /></Field>
          <Field label="Sous-titre (EN)"><DarkInput value={data.subtitle_en} onChange={e => set('subtitle_en', e.target.value)} rows={2} testId="hero-subtitle-en" /></Field>
        </div>
      </div>
      <SaveBtn onClick={() => onSave('hero', data)} saving={saving} testId="save-hero-btn" />
    </div>
  );
};

export default HeroEditor;
